module.exports = require('./helpers/bundle-url').getBundleURL('gjBjl') + "logo.c5857b8b.svg";